import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class ShelfToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const color = this.toColor(element);
        const type = this.formatType('POL', element.shape.x, this.depth);
        const shelf = SimpleSapElement.ELEMENT(type, color);
        return [shelf];
    }
}
